import React from 'react';
import styles from '../Operations.module.css';

interface BBPPComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * BBPP - best brand pinacle pct
 * KPI information component
 */
const BBPP: BBPPComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Best Brand Acceptance is the % of Best Brands that are carried by a store.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Offering high quality, differentiated brands to our customers is critical to reaching Higher Ground.<br /><br />
        Aligned with our &quot;Famous for Four&quot; strategy, Best Brands continue to fuel significant growth and provide some immunity to discount websites and big box competitors.<br /><br />
        When comparing similar size and format Ace stores, the stores carrying all or most of the Best Brands have significantly higher sales productivity.
      </div>

      <div className={styles.sectionContent}>
        Brands that are restricted to your store are not counted in the calculation. 
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Platinum: 70% Acceptance of 70% of the Brands<br/>
        Pinnacle: 80% Acceptance of 80% of the Brands
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div>
        Click on the link in the Current Value for Best Brands Acceptance to determine which brands are opportunities.<br/><br/>
        Links to the individual Best Brand pages provide next steps to adding these powerful brands to your store.
      </div>
    </div>
  );
};

BBPP.title = 'Best Brands Acceptance';
BBPP.actionTitle = 'Best Brands Impact Calculator';
BBPP.actionHyperlink = 'dynamicURL:WFC:current';
export default BBPP;

